import React from "react";
import { Provider } from "react-redux";
import configureStore from "./configureStore";

export function ReduxProvider({ children }) {
  const store = configureStore({});

  return <Provider store={store}>{children}</Provider>;
}
